const YANDEX_MAPS_API_URL = 'https://api-maps.yandex.ru/2.1/'

let apiPromise = null

const loadYandexMapsApi = (apiKey) => {
  if (window.ymaps) return Promise.resolve(window.ymaps)
  if (apiPromise) return apiPromise

  apiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `${YANDEX_MAPS_API_URL}?lang=ru_RU&apikey=${apiKey}`
    script.async = true
    script.onload = () => window.ymaps.ready(() => resolve(window.ymaps))
    script.onerror = () => {
      apiPromise = null
      reject(new Error('Failed to load Yandex Maps API'))
    }
    document.head.appendChild(script)
  })

  return apiPromise
}

export default loadYandexMapsApi
